import "./index.css";

// import { APITester } from "./APITester";
import { Card, CardContent } from "@/components/ui/card";

// import logo from "./logo.svg";
// import reactLogo from "./react.svg";
import { Button } from "./components/ui/button";

export function App() {
  function btnCLick() {
    alert("Clicou no botão!");
  }
  return (
    <>
      <Card className="max-w-md mx-auto mt-10">
        <CardContent>
          <div className="flex flex-col justify-center items-center w-full min-h-[150px]">
            <Button className="bg-blue-500 text-white"
                    onClick={btnCLick}>
              Click Me
            </Button>
          </div>
        </CardContent>
      </Card>
    </>
  );
}

export default App;
